import { render, staticRenderFns } from "./onCurrentPageChange-editor.vue?vue&type=template&id=6994b1aa&scoped=true&"
import script from "./onCurrentPageChange-editor.vue?vue&type=script&lang=js&"
export * from "./onCurrentPageChange-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6994b1aa",
  null
  
)

export default component.exports